document.addEventListener('DOMContentLoaded', () => {
  const checkoutForm = document.querySelector('.stitchea-checkout-form');
  const memberLogin = document.querySelector('.stitchea-login');

  if (!checkoutForm || !memberLogin) return;

  const loginLink = memberLogin.querySelector('a');
  memberLogin.firstChild.textContent = 'Already a member? ';
  if (loginLink) loginLink.textContent = 'Log in here to download';
  checkoutForm.insertAdjacentElement('afterend', memberLogin);
});

document.addEventListener('submit', async (event) => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) return;
  if (!form.classList.contains('stitchea-checkout-form')) return;

  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const data = new FormData(form);
  const properties = {};

  for (const [key, value] of data.entries()) {
    const match = key.match(/^properties\[(.+)\]$/);
    if (match && value) properties[match[1]] = value;
  }

  if (button) button.disabled = true;

  try {
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: {Accept: 'application/json'},
    });
    if (!cartResponse.ok) throw new Error('Unable to read cart');

    const cart = await cartResponse.json();
    const existingMembership = cart.items.find(
      (item) => String(item.variant_id) === '56238770159988'
    );

    if (existingMembership) {
      if (existingMembership.quantity !== 1) {
        const changeResponse = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({id: existingMembership.key, quantity: 1}),
        });
        if (!changeResponse.ok) throw new Error('Unable to normalize membership quantity');
      }
    } else {
      const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          items: [{
            id: 56238770159988,
            quantity: 1,
            selling_plan: 694614983028,
            properties,
          }],
        }),
      });
      if (!addResponse.ok) throw new Error('Unable to prepare checkout');
    }

    window.location.assign('/checkout');
  } catch (error) {
    if (button) button.disabled = false;
    window.alert('We could not prepare your checkout. Please try again.');
  }
}, true);
